// extracted by mini-css-extract-plugin
export default {"icon":"GetStartedPage_icon__go5-2"};